import { toNum } from "./format";

export function normalizeUser(u = {}) {
  const role = u.role ?? u.typeUser ?? u.type ?? u.rol ?? null;
  const company =
    u.company ??
    (u.companyId ? { id: u.companyId, name: u.companyName ?? u.company_name } : undefined);

  return {
    ...u,
    role,
    companyId: company?.id ?? u.companyId,
    company,
  };
}

export function getUserDisplayName(u = {}) {
  const fallback = `${u.firstName ?? ""} ${u.lastName ?? ""}`.trim();
  return u.name || fallback || u.identification || `Usuario #${toNum(u.id) ?? "—"}`;
}

export const getUserCompanyId = (u={}) =>
  u?.company?.id ?? u.companyId ?? u.company_id ?? null;

export const getUserDni = (u={}) =>
  u.identification ?? u.dni ?? u.documentId ?? null;

export const getUserIdOrEmail = (u = {}) =>
  u.identification ?? u.dni ?? u.documentId ?? u.email ?? "—";
